import { Component, ViewChild, ElementRef, Input, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'nxi-f2-title',
    templateUrl: './f2.title.html'
})
export class NxiF2Title implements OnDestroy {
    displayTitle: string;
    @Input() title: string;
    f2Url: string;

    @ViewChild('f2title') f2TitleRef: ElementRef;

    constructor(private router: Router, private translationService: PershingTranslationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');
    }

    @HostListener('document:f2Title', ['$event'])
    titleChange(event: any) {
        console.log(' title event', event.detail.title);
        this.translationService.get(event.detail.title).subscribe(
        res => {
                this.displayTitle = res;
        });
        // storage
        // console.log('setting title event:: displayTitle ', this.displayTitle);
    }

    ngOnInit() {
        this.f2Url = this.router.url;
        // console.log('url:: ', this.f2Url);
        // console.log('setting title :: ', this.title , ' displayTitle ', this.displayTitle);
        // if(!this.displayTitle) { // check in storage
        if (this.f2Url.indexOf('/stocks/summary') > -1) {
            this.title = 'MOD_F2_TITLE.STOCK_RESEARCH';
        } else if (this.f2Url.indexOf('/etf/etfsummary') > -1) {
            this.title = 'MOD_F2_TITLE.ETF_RESEARCH';
        } else if (this.f2Url.indexOf('/mutualfunds/mfsummary') > -1) {
            this.title = 'MOD_F2_TITLE.MF_RESEARCH';
        } else {
            if (this.title) {
                this.title =  'MOD_F2_TITLE.' + this.title;
            }
        }
        this.translationService.get(this.title).subscribe(
        res => {
                this.displayTitle = res;
        });
        console.log('setting title :: displayTitle ', this.displayTitle);
    }

    ngOnDestroy() {
        if (this.f2TitleRef.nativeElement) {
            this.f2TitleRef.nativeElement.remove();
        }
    }
}
